import { createAsyncThunk } from "@reduxjs/toolkit";
import { TServiceError } from "types/general";
import { toastMessage } from "components/ToastMessage";
import { getAssetDashboardDemographics } from "api/getAssetDashboardDemographics";
import { DEMOGRAPHICS_SLICE_NAME } from "./constants";
import { IDemographicsResponse } from "./types";

export const fetchDemographics = createAsyncThunk<
  IDemographicsResponse,
  string,
  { rejectValue: TServiceError }
>(
  `${DEMOGRAPHICS_SLICE_NAME}/fetchDemographics`,
  async (propertyId, { rejectWithValue }) => {
    try {
      return await getAssetDashboardDemographics(propertyId);
    } catch (err) {
      toastMessage({
        message: "Failed to load demographics. Please try again.",
        type: "error",
        position: "top-right",
      });

      return rejectWithValue({
        code: err.code,
        message: err.response?.data ?? err.message,
      });
    }
  }
);
